import Vue from 'vue'
import Store from '@/state'
import Router from 'vue-router'
import { CheckAuth, PingToken } from '@/view/login/brain'
// ============
// routes
// ============
import ShowIcons from '@/components/primitives/icons/ShowIcons'
import * as LoginRouter from './login'
import WelcomeRouter from './welcome'
import * as RecordRoutes from './record'
import * as EventsRoutes from './event'
import * as ItemRoutes from './item'
import * as ItemAssociationRoute from './item-association'
import * as ItemQuoteRoute from './item-quote'
import * as ResearchRoutes from './research'
import * as BoardRoute from './board'
import * as BidMirrorRoute from './bid-mirror'
import * as Dashboard from './dashboard'
import * as ItemPricingRoute from './item-pricing'

Vue.use(Router)

const routes = [
  {
    path: '/icons',
    name: 'Icons',
    component: ShowIcons
  },
  WelcomeRouter,
  ...Object.values(LoginRouter),
  ...Object.values(RecordRoutes),
  ...Object.values(EventsRoutes),
  ...Object.values(ItemRoutes),
  ...Object.values(ItemAssociationRoute),
  ...Object.values(ItemQuoteRoute),
  ...Object.values(ResearchRoutes),
  ...Object.values(BoardRoute),
  ...Object.values(BidMirrorRoute),
  ...Object.values(Dashboard),
  ...Object.values(ItemPricingRoute)
]

const router = new Router({
  mode: 'history',
  saveScrollPosition: true,
  routes
})

// ============
// before each
// ============
router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.auth === true) {
    const pingToken = await PingToken()
    if (!pingToken) return next({path: '/login'})

    refreshUserData()

    const authCheck = CheckAuth()
    const permissionArea = to.meta && to.meta.area ? to.meta.area : null
    const permission = Store.getters['Login/HAS_PERMISSION_IN_AREA']({area: permissionArea, action: 'SHOW'})
    if (authCheck && permission) {
      next()
    } else {
      next({path: '/login'})
    }
  } else {
    next()
  }
})

// ============
// Update Vuex based on local storage
// ============
const refreshUserData = () => {
  const permission = Store.getters['Login/HAS_PERMISSION_SETTED']
  const storageUsername = window.localStorage.getItem('username')
  const storageUserId = window.localStorage.getItem('userId')
  const storagePermission = window.localStorage.getItem('permissions')
  if (!permission && storageUsername && storagePermission) {
    const parsePermission = JSON.parse(storagePermission)
    Store.commit('Login/SET_LOGIN_INFO', { username: storageUsername, permission: parsePermission, userId: storageUserId })
  }
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js